/**
 * Scrollable table wrapper for mobile responsiveness.
 */

import type { ReactNode } from "react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

interface MarkdownTableProps {
	children?: ReactNode;
}

export function MarkdownTable({ children }: MarkdownTableProps) {
	return (
		<ScrollArea className="my-4 w-full">
			<table className="w-full border-collapse text-sm">{children}</table>
			<ScrollBar orientation="horizontal" />
		</ScrollArea>
	);
}
